import { render, staticRenderFns } from "./Espa.vue?vue&type=template&id=52df5cc4&"
import script from "./Espa.vue?vue&type=script&lang=js&"
export * from "./Espa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports